module.exports = __webpack_public_path__ + "6e38eec35bc1d4e29829f62e77dace99.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PFDinTextPro-Light.ttf
// module id = 48
// module chunks = 0